<!-- 物理因素接触限值噪声 -->
<template>
    <div class="tableBoxShadow">
        <top :toolSort="toolSort"></top>
        <h5 :class="['title', { mobileFontSize: $isMobile }]">ppm与mg/m^3气体浓度单位转换在线计算器</h5>
        <div class="container">
            <div class="left">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="分子量(M)" prop="molecularWeight">
                        <el-input v-model="ruleForm.molecularWeight"></el-input>
                    </el-form-item>
                    <el-form-item label="温度(°C)" prop="temperature">
                        <el-input v-model="ruleForm.temperature"></el-input>
                    </el-form-item>
                    <el-form-item label="大气压(Pa)" prop="atmos">
                        <el-input v-model="ruleForm.atmos"></el-input>
                    </el-form-item>
                    <el-form-item label="已知数据" prop="knownData">
                        <el-input v-model="ruleForm.knownData"></el-input>
                    </el-form-item>
                    <el-form-item label="已知单位" prop="knownUnits">
                        <!-- <el-select v-model="" placeholder="请选择已知单位"> -->
                        <!-- <el-option label="ppm" value="ppm"></el-option> -->
                        <!-- <el-option label="mg/m^3" value="mg"></el-option> -->
                        <!-- <el-option ></el-option>
                        </el-select> -->
                        <el-radio-group v-model="ruleForm.knownUnits" size="small">
                            <el-radio label="pm" border>ppm</el-radio>
                            <el-radio label="mg" border>mg/m^3</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">计算</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-table :data="result" height="320" border style="width: 100%">
                    <el-table-column prop="date" align='center' label="时间" width="100">
                    </el-table-column>
                    <el-table-column prop="ppm" align='center' label="ppm" width="150">
                    </el-table-column>
                    <el-table-column prop="mg" align='center' label="mg/m^3" width="150">
                    </el-table-column>
                    <el-table-column prop="ug" align='center' label="ug/m^3" width="150">
                    </el-table-column>
                </el-table>
                <el-button @click="resetTable()">清空记录</el-button>
            </div>
        </div>
    </div>
</template>

<script>
// 引入标题组件
import top from '../subComponents/top.vue'

export default {
    // 注册组件
    components: {
        top
    },
    data() {
        return {
            toolSort: '',
            ruleForm: {
                // 分子量(M)
                molecularWeight: '',
                // 温度(°C)
                temperature: '',
                // 大气压
                atmos: '',
                // 已知数据
                knownData: '',
                // 已知单位
                knownUnits: '',
            },
            result: [],
            rules: {
                molecularWeight: [
                    { required: true, message: '请输入检测物质的分子量', trigger: 'blur' }
                ],
                temperature: [
                    { required: true, message: '请输入检测环境温度', trigger: 'blur' }
                ],
                atmos: [
                    { required: true, message: '请输入检测环境大气压', trigger: 'blur' }
                ],
                knownData: [
                    { required: true, message: '请输入检测物质的已知数据', trigger: 'blur' }
                ],
                knownUnits: [
                    { required: true, message: '请选择已知数据单位', trigger: 'change' }
                ]
            },
        }
    },
    created() {
        this.toolSort = this.$route.params.sort
    },
    methods: {
        // 计算方法
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return;
                console.log(this.ruleForm);
                // 存放结果
                let result = {};
                // 判断单位
                if (this.ruleForm.knownUnits == "mg") {
                    const { molecularWeight, temperature, atmos, knownData } = this.ruleForm;
                    let sum = (101325 / atmos) * ((273.15 + temperature * 1) / 273.15) * (22.4 / molecularWeight) * knownData
                    // 计算ppm
                    result.ppm = sum.toFixed(4)
                    // 获取时间
                    result.date = new Date().toLocaleString().split(" ")[1];
                    // 计算mg/m^3
                    result.mg = knownData
                    // 计算ug/m^3
                    result.ug = knownData * 1000;
                    this.result.push(result);
                } else {
                    const { molecularWeight, temperature, atmos, knownData } = this.ruleForm;
                    let sum = (atmos / 101325) * (273.15 / (273.15 + temperature * 1)) * (molecularWeight / 22.4) * knownData
                    // 计算mg/m^3
                    result.mg = sum.toFixed(4)
                    // 获取时间
                    result.date = new Date().toLocaleString().split(" ")[1];
                    // 计算ug/m^3
                    result.ug = (sum * 1000).toFixed(4);
                    result.ppm = knownData;
                    this.result.push(result);
                }
            });
        },
        // 表单重置方法
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 清空表格
        resetTable() {
            this.result = []
        }
    },
}
</script>

<style scoped>
.title {
    font-size: 14px;
    color: #666;
    text-align: center;
}

.container {
    display: flex;
    justify-content: space-around;
}

.container .left {
    flex: .5;
    /* width: 100px; */
}

.container .right {
    /* flex: 1; */
}
</style>



// WEBPACK FOOTER //
// src/components/subPage/ppmConversion.vue